import { notification } from "antd";
import axios from "axios";
import { useEffect } from "react";
import { REQUEST_STATUS } from "../../../utils/constants";
import { KEY_TOKEN } from "../../core/variables";

const hostname = process.env.REACT_APP_API_HOST_NAME;
const tenantId = process.env.REACT_APP_API_TENANT_ID;

const axiosSecured = axios.create({
  baseURL: `${hostname}/api`,
  headers: {
    "X-TenantId": tenantId,
    "Content-Type": "application/json",
  },
});

const useAxios = () => {
  useEffect(() => {
    const requestIntercept = axiosSecured.interceptors.request.use(
      async (config) => {
        if (!config.headers["Authorization"]) {
          const token = localStorage.getItem(KEY_TOKEN);
          if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
          }
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
    const responseIntercept = axiosSecured.interceptors.response.use(
      (response) => {
        if (response.data?.status === REQUEST_STATUS.error) {
          notification.error({
            message: "An Unexpected Error Occurred",
            description: response.data.message,
          });
          return Promise.resolve(new Error(response.data.message));
        }
        return response;
      },
      (error) => {
        if (!error.config.__isIntercepted) {
          error.config.__isIntercepted = true;
          notification.error({
            message: "An Unexpected Error Occurred",
            description: error.response?.data?.message ?? error.message,
          });
        }
        return Promise.resolve(
          !error.config.__isIntercepted ? error.response : {}
        );
      }
    );

    return () => {
      axiosSecured.interceptors.request.eject(requestIntercept);
      axiosSecured.interceptors.response.eject(responseIntercept);
    };
  }, []);

  return axiosSecured;
};

export default useAxios;
